module.exports = __webpack_public_path__ + "static/media/scotland.a73ae3c7.png";